import React, {Fragment, useState, useEffect} from 'react';

import DateRangePicker from './../../common/Form/DateRangePicker/DateRangePicker';
import dateFormat from 'dateformat';
import {Category} from './../Category';
import {Period} from './../Period';
import {HorizontalLine} from '../HorizontalLine';
import {Footer} from '../Footer';
import {REPORT_COMPONENTS} from './../config';
import {logPageLoadEvents, logOmniClick} from '@ibibo/analytics';
import {userSelector} from '@ibibo/user-reducer';
import {getCookie} from './../../../../utils/getCookie';
import {redirectToSameWindowWithoutRefresh, getCrid} from './../../../../utils/redirectWithCrId';
import {useSelector} from 'react-redux';

export default function TransactionReport({data}) {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [categoryId, updateCategoryId] = useState('');
  const [periodData, updatePeriodData] = useState({});
  const userInfoSelector = useSelector(userSelector);
  const ccdeCookie = getCookie('ccde');
  const isGCC = ccdeCookie == 'AE';

  useEffect(() => {
    const {userInfo = {}} = userInfoSelector || {};
    const {account_id = ''} = userInfo;
    logPageLoadEvents('reports:mysettings', {
      eVar15: `myPartner_transactionReport|mypartner`,
      eVar67: `${account_id || ''}`, //mypartner agent id
      prop27: '/agent/transactionreport/',
      eVar37: isGCC
        ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
        : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
    });
    const crId = getCrid();
    if (!crId) {
      redirectToSameWindowWithoutRefresh('/agent/transactionreport');
    }
  }, []);

  const getPeriodOmniId = id => {
    let periodOminId = '';

    switch (id) {
      case 'LAST_QUARTER':
        periodOminId = 'LQ';
        break;
      case 'CURR_QUARTER':
        periodOminId = 'CQ';
        break;
      case 'CURR_FY':
        periodOminId = 'CY';
        break;
      case 'PREVIOUS_FY':
        periodOminId = 'LY';
        break;
      case 'THIS_WEEK':
        periodOminId = 'TW';
        break;
      case 'THIS_MONTH':
        periodOminId = 'TM';
        break;
      default:
        break;
    }
    return periodOminId;
  };

  const renderComponentView = (componentName, componentData) => {
    let subComponentName = componentData?.component;
    switch (subComponentName) {
      case REPORT_COMPONENTS.CATEGORY:
        return (
          <Category
            data={componentData?.data}
            key={componentName}
            updateCategoryId={updateCategoryId}
            categoryId={categoryId}
          ></Category>
        );
      case REPORT_COMPONENTS.PERIOD:
        return (
          <Period
            data={componentData?.data}
            classes={componentData?.icon?.iconClasses}
            key={componentName}
            periodData={periodData}
            updatePeriodData={data => {
              updatePeriodData(data);
              if (from || to) {
                setFrom('');
                setTo('');
              }

              const periodOminId = getPeriodOmniId(data?.id);

              logOmniClick('reports:mysettings:reportSelection:report_type', {
                prop54: `transactionReport_widget_clicked_${periodOminId}`,
                eVar15: `myPartner_transactionReport|mypartner`,
                eVar37: isGCC
                  ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
                  : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
              });
            }}
            from={from}
            to={to}
            setFrom={setFrom}
            setTo={setTo}
          ></Period>
        );

      case REPORT_COMPONENTS.DATE_RANGE_PICKER:
        return (
          <DateRangePicker
            key={componentName}
            startLabel="Start Date"
            endLabel="End Date"
            name={componentName}
            singleDate={false}
            mode={'range'}
            from={from}
            to={to}
            setFrom={data => {
              setFrom(data);
              to ? updatePeriodData({}) : null;
            }}
            setTo={data => {
              setTo(data);
              from ? updatePeriodData({}) : null;
            }}
            isMandatory={false}
          />
        );
      case REPORT_COMPONENTS.LINE_WITH_TEXT:
        return <HorizontalLine data={componentData?.data} key={componentName}></HorizontalLine>;

      default:
        return null;
    }
  };
  const renderComponent = () => {
    return data?.body?.order?.map((componentName, index) => {
      const componentData = data.body?.data[componentName];
      return renderComponentView(componentName, componentData);
    });
  };
  const onClickCb = actions => {
    actions.forEach(action => {
      if (action?.type === 'API_CALL') {
        const format = 'yyyy-mm-dd';
        let startDate = '',
          endDate = '';

        let periodOminId = getPeriodOmniId(data?.id);

        if (from && to) {
          startDate = dateFormat(from, format);
          endDate = dateFormat(to, format);
          periodOminId = 'custom';
        } else {
          startDate = periodData?.startDate;
          endDate = periodData?.endDate;
        }
        const downloadUrl = `${action?.api?.url}lob=${categoryId}&start_date=${startDate}&last_date=${endDate}`;

        logOmniClick('reports:mysettings:download', {
          prop54: `transactionReport|${categoryId}|defined_${periodOminId}`,
          eVar15: `myPartner_transactionReport|mypartner`,
          eVar37: isGCC
            ? 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng'
            : 'domain_sbu:mypartner|domain_country:india|domain_currency:inr|domain_language:eng',
        });
        window.open(downloadUrl, '_blank');
      }
    });
  };

  return (
    <Fragment>
      {renderComponent()}
      {/* <S.InfoContainer>

                    <p>
                        <span className="new">NEW</span>
                        Receive your monthly transactional reports on
                        <span> abc@mypartner.com</span> by using the <span> Schedule Report feature</span>
                        .
                    </p>
                </S.InfoContainer> */}

      <Footer data={data?.footer?.ctas} onClickCb={onClickCb}></Footer>
    </Fragment>
  );
}
